import axios from "../axios";

// 获取人才认定列表
export const get_talent_list = (params) => {
    return axios('get', '/api/talent/get_talent_list', params);
}

// 获取人才认定详情
export const get_talent_detail = (params) => {
    return axios('get', '/api/talent/get_talent_info', params);
}

// 跳转认定详情页判断认定是否删除
export const judge_talent_exist = (params) => {
    return axios('get', '/api/talent/judge_talent_exist', params);
}
// 跳转认定详情页判断政策是否删除
export const judge_policy_exist = (params) => {
    return axios('get', '/api/policy/judge_policy_exist', params);
}

export const add_talent_user_info = (params) => {
    return axios('post', '/api/talent/add_talent_user_info', params);
}

export const get_talent_user_info = () => {
    return axios('get', '/api/talent/get_talent_user_info', null);
}

export const get_user_talent_by_info = (params) => {
    return axios('get', '/api/talent/get_user_talent_by_info', params);
}

export const get_user_talent = (params) => {
    return axios('get', '/api/talent/get_user_talent', params);
}




